// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWebhookEndpointMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  url: Types.Scalars["String"]["input"];
  headers?: Types.InputMaybe<
    Array<Types.WebhookHeaderInput> | Types.WebhookHeaderInput
  >;
}>;

export type CreateWebhookEndpointMutation = {
  __typename?: "Mutation";
  createWebhookEndpoint?: { __typename?: "WebhookEndpoint"; id: string } | null;
};

export type UpdateWebhookEndpointMutationVariables = Types.Exact<{
  webhookEndpointId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  url?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  headers?: Types.InputMaybe<
    Array<Types.WebhookHeaderInput> | Types.WebhookHeaderInput
  >;
  enabled?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type UpdateWebhookEndpointMutation = {
  __typename?: "Mutation";
  updateWebhookEndpoint?: {
    __typename?: "WebhookEndpoint";
    id: string;
    name: string;
    url: string;
    headerNames: Array<string>;
    disabledAt?: number | null;
    disabledReason?: string | null;
    consecutiveFailures: number;
    lastFailureAt?: number | null;
  } | null;
};

export type DeleteWebhookEndpointMutationVariables = Types.Exact<{
  webhookEndpointId: Types.Scalars["ID"]["input"];
}>;

export type DeleteWebhookEndpointMutation = {
  __typename?: "Mutation";
  deleteWebhookEndpoint?: { __typename?: "WebhookEndpoint"; id: string } | null;
};

export type TestWebhookDestinationMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  url?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  headers?: Types.InputMaybe<
    Array<Types.WebhookHeaderInput> | Types.WebhookHeaderInput
  >;
  webhookEndpointId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type TestWebhookDestinationMutation = {
  __typename?: "Mutation";
  testWebhookDestination?: {
    __typename?: "WebhookTestResult";
    status: string;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorMessage?: string | null;
  } | null;
};

export type FindOrCreateWebhookSigningKeyMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type FindOrCreateWebhookSigningKeyMutation = {
  __typename?: "Mutation";
  findOrCreateWebhookSigningKey?: {
    __typename?: "WebhookSigningKey";
    id: string;
  } | null;
};

export const CreateWebhookEndpointDocument = gql`
  mutation CreateWebhookEndpoint(
    $organizationSlug: ID!
    $name: String!
    $url: String!
    $headers: [WebhookHeaderInput!]
  ) {
    createWebhookEndpoint(
      organizationSlug: $organizationSlug
      name: $name
      url: $url
      headers: $headers
    ) {
      id
    }
  }
`;
export type CreateWebhookEndpointMutationFn = Apollo.MutationFunction<
  CreateWebhookEndpointMutation,
  CreateWebhookEndpointMutationVariables
>;

/**
 * __useCreateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useCreateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookEndpointMutation, { data, loading, error }] = useCreateWebhookEndpointMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useCreateWebhookEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWebhookEndpointMutation,
    CreateWebhookEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWebhookEndpointMutation,
    CreateWebhookEndpointMutationVariables
  >(CreateWebhookEndpointDocument, options);
}
export type CreateWebhookEndpointMutationHookResult = ReturnType<
  typeof useCreateWebhookEndpointMutation
>;
export type CreateWebhookEndpointMutationResult =
  Apollo.MutationResult<CreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<
  CreateWebhookEndpointMutation,
  CreateWebhookEndpointMutationVariables
>;
export const UpdateWebhookEndpointDocument = gql`
  mutation UpdateWebhookEndpoint(
    $webhookEndpointId: ID!
    $name: String
    $url: String
    $headers: [WebhookHeaderInput!]
    $enabled: Boolean
  ) {
    updateWebhookEndpoint(
      webhookEndpointId: $webhookEndpointId
      name: $name
      url: $url
      headers: $headers
      enabled: $enabled
    ) {
      id
      name
      url
      headerNames
      disabledAt
      disabledReason
      consecutiveFailures
      lastFailureAt
    }
  }
`;
export type UpdateWebhookEndpointMutationFn = Apollo.MutationFunction<
  UpdateWebhookEndpointMutation,
  UpdateWebhookEndpointMutationVariables
>;

/**
 * __useUpdateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEndpointMutation, { data, loading, error }] = useUpdateWebhookEndpointMutation({
 *   variables: {
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      headers: // value for 'headers'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateWebhookEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWebhookEndpointMutation,
    UpdateWebhookEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWebhookEndpointMutation,
    UpdateWebhookEndpointMutationVariables
  >(UpdateWebhookEndpointDocument, options);
}
export type UpdateWebhookEndpointMutationHookResult = ReturnType<
  typeof useUpdateWebhookEndpointMutation
>;
export type UpdateWebhookEndpointMutationResult =
  Apollo.MutationResult<UpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<
  UpdateWebhookEndpointMutation,
  UpdateWebhookEndpointMutationVariables
>;
export const DeleteWebhookEndpointDocument = gql`
  mutation DeleteWebhookEndpoint($webhookEndpointId: ID!) {
    deleteWebhookEndpoint(webhookEndpointId: $webhookEndpointId) {
      id
    }
  }
`;
export type DeleteWebhookEndpointMutationFn = Apollo.MutationFunction<
  DeleteWebhookEndpointMutation,
  DeleteWebhookEndpointMutationVariables
>;

/**
 * __useDeleteWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookEndpointMutation, { data, loading, error }] = useDeleteWebhookEndpointMutation({
 *   variables: {
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useDeleteWebhookEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWebhookEndpointMutation,
    DeleteWebhookEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWebhookEndpointMutation,
    DeleteWebhookEndpointMutationVariables
  >(DeleteWebhookEndpointDocument, options);
}
export type DeleteWebhookEndpointMutationHookResult = ReturnType<
  typeof useDeleteWebhookEndpointMutation
>;
export type DeleteWebhookEndpointMutationResult =
  Apollo.MutationResult<DeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<
  DeleteWebhookEndpointMutation,
  DeleteWebhookEndpointMutationVariables
>;
export const TestWebhookDestinationDocument = gql`
  mutation TestWebhookDestination(
    $organizationSlug: ID!
    $url: String
    $headers: [WebhookHeaderInput!]
    $webhookEndpointId: ID
  ) {
    testWebhookDestination(
      organizationSlug: $organizationSlug
      url: $url
      headers: $headers
      webhookEndpointId: $webhookEndpointId
    ) {
      status
      responseStatus
      responseBodyExcerpt
      errorMessage
    }
  }
`;
export type TestWebhookDestinationMutationFn = Apollo.MutationFunction<
  TestWebhookDestinationMutation,
  TestWebhookDestinationMutationVariables
>;

/**
 * __useTestWebhookDestinationMutation__
 *
 * To run a mutation, you first call `useTestWebhookDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestWebhookDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testWebhookDestinationMutation, { data, loading, error }] = useTestWebhookDestinationMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      url: // value for 'url'
 *      headers: // value for 'headers'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useTestWebhookDestinationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestWebhookDestinationMutation,
    TestWebhookDestinationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestWebhookDestinationMutation,
    TestWebhookDestinationMutationVariables
  >(TestWebhookDestinationDocument, options);
}
export type TestWebhookDestinationMutationHookResult = ReturnType<
  typeof useTestWebhookDestinationMutation
>;
export type TestWebhookDestinationMutationResult =
  Apollo.MutationResult<TestWebhookDestinationMutation>;
export type TestWebhookDestinationMutationOptions = Apollo.BaseMutationOptions<
  TestWebhookDestinationMutation,
  TestWebhookDestinationMutationVariables
>;
export const FindOrCreateWebhookSigningKeyDocument = gql`
  mutation FindOrCreateWebhookSigningKey($organizationSlug: ID!) {
    findOrCreateWebhookSigningKey(organizationSlug: $organizationSlug) {
      id
    }
  }
`;
export type FindOrCreateWebhookSigningKeyMutationFn = Apollo.MutationFunction<
  FindOrCreateWebhookSigningKeyMutation,
  FindOrCreateWebhookSigningKeyMutationVariables
>;

/**
 * __useFindOrCreateWebhookSigningKeyMutation__
 *
 * To run a mutation, you first call `useFindOrCreateWebhookSigningKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateWebhookSigningKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateWebhookSigningKeyMutation, { data, loading, error }] = useFindOrCreateWebhookSigningKeyMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useFindOrCreateWebhookSigningKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FindOrCreateWebhookSigningKeyMutation,
    FindOrCreateWebhookSigningKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FindOrCreateWebhookSigningKeyMutation,
    FindOrCreateWebhookSigningKeyMutationVariables
  >(FindOrCreateWebhookSigningKeyDocument, options);
}
export type FindOrCreateWebhookSigningKeyMutationHookResult = ReturnType<
  typeof useFindOrCreateWebhookSigningKeyMutation
>;
export type FindOrCreateWebhookSigningKeyMutationResult =
  Apollo.MutationResult<FindOrCreateWebhookSigningKeyMutation>;
export type FindOrCreateWebhookSigningKeyMutationOptions =
  Apollo.BaseMutationOptions<
    FindOrCreateWebhookSigningKeyMutation,
    FindOrCreateWebhookSigningKeyMutationVariables
  >;
